// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inner_mapping_obj_spe {
  border: 1px solid var(--rm-primary-border);
  padding: 8px 14px;
  background-color: var(--rm-surface);
  font-weight: 600;
  color: var(--rm-primary);
  border-radius: var(--rm-radius);
  margin: 4px 8px 4px 4px;
  text-align: center;
  font-size: 13px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.nested-info_spe {
  border-left: 2px solid var(--rm-border);
  padding: 2px 0 2px 8px;
  margin-left: 16px;
  background: none;
  font-size: 13px;
}

.value_spe .inner_mapping_inner_spe {
  border: 1px solid var(--rm-primary-border);
  padding: 6px 12px;
  background-color: var(--rm-primary-dim);
  border-radius: var(--rm-radius);
  margin: 3px;
  text-align: center;
  color: var(--rm-text);
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/SpecificSubmodelDetails.scss"],"names":[],"mappings":"AAAA;EACI,0CAAA;EACA,iBAAA;EACA,mCAAA;EACA,gBAAA;EACA,wBAAA;EACA,+BAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,yCAAA;AACJ;;AAEA;EACI,uCAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;AACJ;;AAGI;EACI,0CAAA;EACA,iBAAA;EACA,uCAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;AAAR","sourcesContent":[".inner_mapping_obj_spe {\r\n    border: 1px solid var(--rm-primary-border);\r\n    padding: 8px 14px;\r\n    background-color: var(--rm-surface);\r\n    font-weight: 600;\r\n    color: var(--rm-primary);\r\n    border-radius: var(--rm-radius);\r\n    margin: 4px 8px 4px 4px;\r\n    text-align: center;\r\n    font-size: 13px;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.nested-info_spe {\r\n    border-left: 2px solid var(--rm-border);\r\n    padding: 2px 0 2px 8px;\r\n    margin-left: 16px;\r\n    background: none;\r\n    font-size: 13px;\r\n}\r\n\r\n.value_spe {\r\n    .inner_mapping_inner_spe {\r\n        border: 1px solid var(--rm-primary-border);\r\n        padding: 6px 12px;\r\n        background-color: var(--rm-primary-dim);\r\n        border-radius: var(--rm-radius);\r\n        margin: 3px;\r\n        text-align: center;\r\n        color: var(--rm-text);\r\n        font-size: 13px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
